module.exports = __webpack_public_path__ + "img/GLT-LOGISTICS.b8ff04d5.svg";